import "./index.css";
import "./lib/fonts";
import { createBrowserRouter, RouterProvider } from "react-router";
import { Landing } from "./pages/Landing";
import { Rooms } from "./pages/Rooms";
import { MyRooms } from "./pages/MyRooms";
import { CreateRoom } from "./pages/CreateRoom";
import { Room } from "./pages/Room";
import { About } from "./pages/About";
import { AdminLogin } from "./pages/admin/Login";
import { AdminDashboard } from "./pages/admin/Dashboard";

const router = createBrowserRouter([
	{ path: "/", element: <Landing /> },
	{ path: "/create-room", element: <CreateRoom /> },
	{ path: "/my-rooms", element: <MyRooms /> },
	{ path: "/rooms", element: <Rooms /> },
	{ path: "/room/:roomId", element: <Room /> },
	{ path: "/about", element: <About /> },
	{ path: "/admin/login", element: <AdminLogin /> },
	{ path: "/admin", element: <AdminDashboard /> },
]);

export function App() {
	return <RouterProvider router={router} />;
}

export default App;
